// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Account_wrapper__OC8f-","store":"Account_store__2Ui76","name":"Account_name__L6Cn9","fullname":"Account_fullname__3jbjL"};